import React, { useState, useEffect } from 'react';
import Modal from '../../../ui-kit/Modal';
import Button from '../../../ui-kit/Button';
import { Ban } from 'lucide-react';
import { DO_NOT_SHIP_REASONS, doNotShipStatus } from '../logic/telesales';

// Flag / unflag a customer as "Do Not Ship" with a reason + note.
const DoNotShipModal = ({ isOpen, onClose, customer, onSubmit, loading }) => {
    const current = doNotShipStatus(customer);
    const [reason, setReason] = useState(DO_NOT_SHIP_REASONS[0]);
    const [note, setNote] = useState('');

    useEffect(() => {
        if (!isOpen) return;
        setReason(current.reason || DO_NOT_SHIP_REASONS[0]);
        setNote(current.note || '');
    }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

    const inputCls = 'w-full px-3 py-2 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-red-100';

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Do Not Ship" className="max-w-md">
            <div className="space-y-4">
                <div className="bg-red-50 border border-red-100 rounded-lg p-3 text-sm text-red-700 flex items-start gap-2">
                    <Ban size={16} className="mt-0.5 shrink-0" />
                    <span>
                        Flagging <b>{customer?.name || 'this customer'}</b> ({customer?.primaryMobile || customer?.mobile})
                        warns staff before any order for this number is shipped.
                    </span>
                </div>

                <label className="block text-xs font-medium text-slate-500">Reason
                    <select className={inputCls} value={reason} onChange={e => setReason(e.target.value)}>
                        {DO_NOT_SHIP_REASONS.map(r => <option key={r} value={r}>{r}</option>)}
                    </select>
                </label>

                <label className="block text-xs font-medium text-slate-500">Note (optional)
                    <textarea className={inputCls} rows={3} value={note} onChange={e => setNote(e.target.value)}
                        placeholder="e.g. returned 3 COD orders unopened" />
                </label>

                <div className="flex items-center justify-between pt-1">
                    {current.flagged ? (
                        <button
                            onClick={() => onSubmit({ on: false })}
                            disabled={loading}
                            className="text-sm font-medium text-slate-600 hover:text-slate-800 underline"
                        >
                            Remove flag
                        </button>
                    ) : <span />}
                    <div className="flex gap-2">
                        <Button variant="outline" onClick={onClose}>Cancel</Button>
                        <Button onClick={() => onSubmit({ on: true, reason, note })} disabled={loading}>
                            <Ban size={15} /> {loading ? 'Saving…' : (current.flagged ? 'Update Flag' : 'Mark Do Not Ship')}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default DoNotShipModal;
